import { OPTION_TYPES } from '@/components/content/Header/constants';
import { AutocompleteOption } from '@/components/content/Header/parts/AutocompleteOption';
import { autocompleteSX } from '@/components/content/Header/styles/search';
import { capitalizeFirstLetter, highlightDiff } from '@/components/content/Header/utils/search';
import { SuggestOption } from '@/data/types/Search';
import { toCamelCase } from '@/utils/toCamelCase';
import { AutocompleteRenderGroupParams, Box, Typography } from '@mui/material';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

export const renderGroupFunction =
	(titles: Record<string, string>) => (params: AutocompleteRenderGroupParams) => {
		const isKeyword = params.group === OPTION_TYPES.Keyword;
		const isRecentProduct = params.group === OPTION_TYPES.RecentProduct;

		return (
			<Box key={params.key} sx={!isKeyword ? autocompleteSX.groupContainer : undefined}>
				<Typography variant="bodySubText" sx={autocompleteSX.groupTitle}>
					{titles[params.group] ?? params.group}
				</Typography>
				<Box
					sx={
						isRecentProduct
							? autocompleteSX.groupContentContainerRecent
							: isKeyword
							? autocompleteSX.groupContentContainerKeyword
							: autocompleteSX.groupContentContainer
					}
				>
					{params.children}
				</Box>
			</Box>
		);
	};

export const renderOptionFunction =
	(
		inputValue: string,
		onSubmit?: (entry: { label: string; href?: string }) => void | Promise<void>
	) =>
	(props: React.HTMLAttributes<HTMLLIElement>, option: SuggestOption): React.ReactNode => {
		const { label, identifier, thumbnail } = option;
		if (label === '') return null;

		const isCategory = identifier === OPTION_TYPES.Category;
		const isKeyword = identifier === OPTION_TYPES.Keyword;
		const isRecentSearch = identifier === OPTION_TYPES.RecentSearch;

		const displayLabel = isCategory ? label.split('>').pop() ?? '' : label;

		const formattedLabel = capitalizeFirstLetter(displayLabel) || '';

		const highlightedParts = highlightDiff(formattedLabel, inputValue);

		const optionIcon =
			(isCategory
				? thumbnail
				: isKeyword
				? MATERIAL_SYMBOL_ICONS.search
				: isRecentSearch
				? MATERIAL_SYMBOL_ICONS.history
				: MATERIAL_SYMBOL_ICONS.verified) ?? '';

		const searchTermLabel = isCategory ? label : label.replaceAll('+', ' ').replaceAll('.', '');

		return (
			<AutocompleteOption
				option={{
					...option,
					label: searchTermLabel,
				}}
				parts={highlightedParts}
				icon={toCamelCase(optionIcon)}
				props={props}
				onSubmit={onSubmit}
			/>
		);
	};
